import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.meditation.fields.id'),
  },
  {
    name: 'title',
    label: i18n('entities.meditation.fields.title'),
  },
  {
    name: 'duration',
    label: i18n('entities.meditation.fields.duration'),
  },
  {
    name: 'description',
    label: i18n('entities.meditation.fields.description'),
  },
  {
    name: 'summary',
    label: i18n('entities.meditation.fields.summary'),
  },
  {
    name: 'slug',
    label: i18n('entities.meditation.fields.slug'),
  },
  {
    name: 'orderInList',
    label: i18n('entities.meditation.fields.orderInList'),
  },
  {
    name: 'type',
    label: i18n('entities.meditation.fields.type'),
  },
  {
    name: 'archivedBy',
    label: i18n('entities.meditation.fields.archivedBy'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'archivedAt',
    label: i18n('entities.meditation.fields.archivedAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.meditation.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.meditation.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
